const isValidEmail = (email) => {
    let emailRegexPattern = /^\S+@\S+\.\S+$/
    return emailRegexPattern.test(email)
}

const isValidPhoneNumber = (email) => {
    let phoneRegexPattern = /^\+1\d{10}$/
    return phoneRegexPattern.test(email)
}

const formattedDate = (dateString) => {
    let date = new Date(dateString);
    let today = new Date();

    var formattedDate;

    if (date.getMonth() == today.getMonth() && date.getDate() == today.getDate()) {
        formattedDate = "Today";
    } else {
        formattedDate = date.toLocaleDateString()
    }

    return formattedDate;
}
const formattedTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString()
}

export {
    isValidEmail,
    isValidPhoneNumber,
    formattedDate,
    formattedTime
}